import React from "react";
import PropTypes from "prop-types";
import { OrderedMap, List } from "immutable";
import {
    ReportingViewTemplate
    // FilterBuilderTemplate
} from "../templates";
import { Row, Col, Tabs, Statistic, Checkbox, Button } from "antd";
import { ReportsService } from "services/index";
import { ReportsFilter } from "components";
import {
    columnBuilder,
    rowBuilder,
    filterBuilder
} from "utilities/table-utils";
import "./../styles/reports.css";
import { formatCurrency } from "./../utils/currency";
import { ellipsisTextWithHtml } from "../components/ellipsis-text";
// import { formatCurrency } from "../utils";

const { TabPane } = Tabs;
class ReportsView extends React.PureComponent {
    state = {
        reportId: this.props.match.params.reportId,
        reportName: this.props.location.state.reports.name,
        categories: new List([]),
        activeCategory: null,
        rows: new List([]),
        columns: new OrderedMap({}),
        filters: new OrderedMap({}),
        filterValues: {},
        categoryLoading: true,
        tableLoading: false,
        dataLoading: false,
        loading: true,
        notShowDecimals: true
    };

    changeDecimalView = () => {
        this.setState({
            notShowDecimals: !this.state.notShowDecimals
        });
    };

    componentDidMount() {
        this.fetchReportCategories();
    }
    componentDidUpdate() {
        if (this.props.match.params.reportId !== this.state.reportId) {
            this.setState(
                {
                    reportId: this.props.match.params.reportId,
                    reportName: this.props.location.state.reports.name
                },
                () => this.fetchReportCategories()
            );
        }
    }

    filterTemplate = null;
    fetchReportCategories() {
        ReportsService.getReportCategories(this.state.reportId).then(_ => {
            if (_.data && _.data.results) {
                this.setState(
                    {
                        categoryLoading: false,
                        categories: new List(_.data.results),
                        activeCategory: _.data.results[0].id,
                        tableLoading: true
                    },
                    () => this.fetchReportDetail()
                );
            }
        });
    }
    fetchReportDetail() {
        ReportsService.getReportDetail(this.state.activeCategory).then(_ => {
            const {
                data: { display_fields, filter_fields }
            } = _;
            this.setState(
                {
                    columns: columnBuilder(
                        display_fields,
                        this.state.notShowDecimals
                    ).map(_ => {
                        if(_.dataIndex === "Remarks"){
                            return {
                                ..._,
                                render: (_, record) => ellipsisTextWithHtml(_, record["Remarks HTML"])
                            };
                        }
                        return _;
                    }),
                    filters: filterBuilder(filter_fields),
                    tableLoading: false
                },
                () => {
                    if (
                        this.state.filters.size > 0 &&
                        Object.keys(this.state.filterValues).length > 0
                    ) {
                        return this.fetchReport(
                            new OrderedMap(this.state.filterValues)
                                .map(_ =>
                                    _._isAMomentObject
                                        ? _.format("YYYY-MM-DD")
                                        : _
                                )
                                .toJS()
                        );
                    }
                    if (filter_fields.length === 0) {
                        this.fetchReport({});
                    }
                }
            );
        });
    }
    fetchReport(filter_values) {
        const { activeCategory: reportId, filters } = this.state;
        if (
            filters.size === 0 ||
            (filters.size > 0 &&
                Object.keys(filter_values).length > 0 &&
                Object.keys(filter_values).length >= filters.size)
        ) {
            this.setState({
                dataLoading: true
            });
            return ReportsService.getReport(reportId, filter_values).then(
                ({ data }) => {
                    if (data) {
                        this.setState({
                            rows: rowBuilder(data),
                            dataLoading: false
                        });
                    }
                }
            );
        }
        this.setState({
            rows: rowBuilder([]),
            dataLoading: false
        });
    }
    onFilterApply = (filterValues, auto = false) => {
        this.setState(
            {
                filterValues
            },
            () => {
                if (auto) {
                    this.onFetchPress();
                }
            }
        );
    };
    onFetchPress = () =>
        this.fetchReport(
            new OrderedMap(this.state.filterValues)
                .map(_ => (_._isAMomentObject ? _.format("YYYY-MM-DD") : _))
                .toJS()
        );

    getTable(reportName) {
        if (!reportName) {
            return null;
        }
        const {
            rows,
            columns,
            filters,
            filterValues,
            activeCategory: reportId,
            tableLoading,
            dataLoading
        } = this.state;
        if (tableLoading) {
            return "Loading";
        }
        return (
            <Row>
                <Col
                    span={24}
                    className={
                        "d-flex justify-content-space-between align-items-center"
                    }
                >
                    <ReportsFilter
                        reportId={reportId}
                        filters={filters}
                        values={filterValues}
                        onApply={this.onFilterApply}
                        onFetch={this.onFetchPress}
                    />
                    <Checkbox
                        onChange={val =>
                            this.setState(
                                {
                                    notShowDecimals: !val.target.checked
                                },
                                () => this.fetchReportDetail()
                            )
                        }
                        // checked={!this.state.notShowDecimals}
                    >
                        {"Show Decimal"}
                    </Checkbox>
                </Col>
                <Col
                    span={24}
                    style={{
                        flexDirection: "row",
                        display: "flex",
                        justifyContent: "space-between"
                    }}
                >
                    {columns
                        .filter(_ => _.dataType === 6)
                        .map(_ => (
                            <Row key={_.key}>
                                <Col>
                                    <Statistic
                                        className={"reports-statistics"}
                                        title={_.title}
                                        value={formatCurrency(rows
                                            .reduce(
                                                (agg, val) =>
                                                    (val[_.title]
                                                        ? +val[_.title]
                                                        : +val[_.dataIndex]) +
                                                    agg,
                                                0
                                            ), true)}
                                    />
                                </Col>
                            </Row>
                        ))
                        .toList()
                        .toArray()}
                </Col>
                <Col span={24}>
                    <ReportingViewTemplate
                        rows={rows}
                        columns={columns}
                        loading={dataLoading}
                        reportId={reportId}
                        reportName={reportName}
                        filters={this.state.filterValues}
                    />
                </Col>
            </Row>
        );
    }
    onReportCategoryChange = activeCategory => {
        this.setState(
            {
                activeCategory: Number(activeCategory),
                rows: new List([]),
                columns: new OrderedMap({}),
                tableLoading: true
            },
            () => this.fetchReportDetail()
        );
    };
    render() {
        const { categoryLoading, activeCategory, reportName } = this.state;
        if (categoryLoading) {
            return "Loading";
        }
        // const { reportName } = this.state;
        return (
            <Row>
                <Col span={24} className={"p-5"}>
                    <Button icon={"arrow-left"} onClick={() => this.props.history.goBack()}>{"Back"}</Button>
                </Col>
                <Col span={24} className={"p-5"}>
                    <h2 style={{
                        marginLeft: "5px"
                    }}>{reportName}</h2>
                </Col>
                <Col span={24}>
                    <Tabs
                        activeKey={String(activeCategory)}
                        onChange={this.onReportCategoryChange}
                    >
                        {this.state.categories.map(_ => (
                            <TabPane key={String(_.id)} tab={_.name} />
                        ))}
                    </Tabs>
                </Col>
                <Col span={24}>
                    {this.getTable(
                        (
                            this.state.categories.find(
                                _ => _.id === activeCategory
                            ) || {}
                        ).name
                    )}
                </Col>
            </Row>
        );
    }
}

ReportsView.propTypes = {
    location: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object
};

export default ReportsView;
